// 企业资质
<template>
  <div class="main">
    <div class="head">
      <myheadert></myheadert>
      <img src="~@/assets/aboutMe_img/u6086-4.png" class="title">
    </div>
    <div class="middle">
      <div class="location">
        <img src="~@/assets/common_img/house.png">
        <span class="place">您的位置：&nbsp;<span @click="goHome">主页</span>＞关于我们＞企业资质</span>
      </div>
      <div class="lead">
        <ul>
          <li><a href="#/introduce">企业简介</a></li>
          <li><a href="#/experience">成长历程</a></li>
          <li class="lead_three"><a href="#/business">企业资质</a></li>
          <li><a href="#/address">企业地图</a></li>
          <li><a href="#/contact">联系我们</a></li>
        </ul>
      </div>
      <div class="line"></div>
    </div>
    <div class="business">
      <!-- <iframe frameborder="0" src="/businessleft">
      </iframe> -->
      <div id="business-left">
        <ul>
          <li v-for="(imgs, indexs) in smallimgArray" :key="indexs+1" @click="changeImg(indexs)">
              <img :src='imgs'>
          </li>
        </ul>
      </div>
      <div class="slide" v-on:mouseover="stop()" v-on:mouseout="move()">
      <div class="slideshow">
          <transition-group tag="ul" name="image">
            <li v-for="(img, index) in imgArray" v-show="index===mark" :key="index+1">
              <img :src='img' id="bigImg">
            </li>
          </transition-group>
      </div>
    </div>
      <!-- <div class="business-right" style="width:510px; height:1000px"></div> -->
    </div>
  </div>
</template>
<script>
// import myheader from '../header/header.vue'
export default{
  name: 'business',
  data () {
    return {
      timer: null,
      mark: 0,
      imgArray: [
        require('../../assets/img/br1.jpg'),
        require('../../assets/img/br2.jpg'),
        require('../../assets/img/br3.jpg'),
        require('../../assets/img/br4.jpg'),
        require('../../assets/img/br5.jpg'),
        require('../../assets/img/br6.jpg'),
        require('../../assets/img/br7.jpg'),
        require('../../assets/img/br8.jpg'),
        require('../../assets/img/br9.jpg'),
        require('../../assets/img/br10.jpg'),
        require('../../assets/img/br11.jpg'),
        require('../../assets/img/br12.jpg'),
        require('../../assets/img/br13.jpg'),
        require('../../assets/img/br14.jpg'),
        require('../../assets/img/br15.jpg'),
        require('../../assets/img/br16.jpg'),
        require('../../assets/img/br17.jpg'),
        require('../../assets/img/br18.jpg'),
        require('../../assets/img/br19.jpg'),
        require('../../assets/img/br20.jpg'),
        require('../../assets/img/br21.jpg'),
        require('../../assets/img/br22.jpg'),
        require('../../assets/img/br23.jpg'),
        require('../../assets/img/br24.jpg'),

        require('../../assets/img/br25.jpg'),
        require('../../assets/img/br26.jpg'),
        require('../../assets/img/br27.jpg'),
        require('../../assets/img/br28.jpg'),
        require('../../assets/img/br29.jpg'),
        require('../../assets/img/br30.jpg'),
        require('../../assets/img/br31.jpg'),
        require('../../assets/img/br32.jpg'),
        require('../../assets/img/br33.jpg'),
        require('../../assets/img/br34.jpg'),
        require('../../assets/img/br35.jpg'),
        require('../../assets/img/br36.jpg'),
        require('../../assets/img/br37.jpg'),
        require('../../assets/img/br38.jpg'),
        require('../../assets/img/br39.jpg'),
        require('../../assets/img/br40.jpg'),
        require('../../assets/img/br41.jpg'),
        require('../../assets/img/br42.jpg'),
        require('../../assets/img/br43.jpg'),
        require('../../assets/img/br44.jpg'),
        require('../../assets/img/br45.jpg'),
        require('../../assets/img/br46.jpg'),
        require('../../assets/img/br47.jpg'),
        require('../../assets/img/br48.jpg'),
        require('../../assets/img/br49.jpg'),
        require('../../assets/img/br50.jpg'),
        require('../../assets/img/br51.jpg')
      ],
      smallimgArray: [
        require('../../assets/img/br1.jpg'),
        require('../../assets/img/br2.jpg'),
        require('../../assets/img/br3.jpg'),
        require('../../assets/img/br4.jpg'),
        require('../../assets/img/br5.jpg'),
        require('../../assets/img/br6.jpg'),
        require('../../assets/img/br7.jpg'),
        require('../../assets/img/br8.jpg'),
        require('../../assets/img/br9.jpg'),
        require('../../assets/img/br10.jpg'),
        require('../../assets/img/br11.jpg'),
        require('../../assets/img/br12.jpg'),
        require('../../assets/img/br13.jpg'),
        require('../../assets/img/br14.jpg'),
        require('../../assets/img/br15.jpg'),
        require('../../assets/img/br16.jpg'),
        require('../../assets/img/br17.jpg'),
        require('../../assets/img/br18.jpg'),
        require('../../assets/img/br19.jpg'),
        require('../../assets/img/br20.jpg'),
        require('../../assets/img/br21.jpg'),
        require('../../assets/img/br22.jpg'),
        require('../../assets/img/br23.jpg'),
        require('../../assets/img/br24.jpg'),
        require('../../assets/img/br25.jpg'),
        require('../../assets/img/br26.jpg'),
        require('../../assets/img/br27.jpg'),
        require('../../assets/img/br28.jpg'),
        require('../../assets/img/br29.jpg'),
        require('../../assets/img/br30.jpg'),
        require('../../assets/img/br31.jpg'),
        require('../../assets/img/br32.jpg'),
        require('../../assets/img/br33.jpg'),
        require('../../assets/img/br34.jpg'),
        require('../../assets/img/br35.jpg'),
        require('../../assets/img/br36.jpg'),
        require('../../assets/img/br37.jpg'),
        require('../../assets/img/br38.jpg'),
        require('../../assets/img/br39.jpg'),
        require('../../assets/img/br40.jpg'),
        require('../../assets/img/br41.jpg'),
        require('../../assets/img/br42.jpg'),
        require('../../assets/img/br43.jpg'),
        require('../../assets/img/br44.jpg'),
        require('../../assets/img/br45.jpg'),
        require('../../assets/img/br46.jpg'),
        require('../../assets/img/br47.jpg'),
        require('../../assets/img/br48.jpg'),
        require('../../assets/img/br49.jpg'),
        require('../../assets/img/br50.jpg'),
        require('../../assets/img/br51.jpg')
        // require('../../assets/business_img_l/bl1.jpg'),
        // require('../../assets/business_img_l/bl2.jpg'),
        // require('../../assets/business_img_l/bl3.jpg'),
        // require('../../assets/business_img_l/bl4.jpg'),
        // require('../../assets/business_img_l/bl5.jpg'),
        // require('../../assets/business_img_l/bl6.jpg'),
        // require('../../assets/business_img_l/bl7.jpg'),
        // require('../../assets/business_img_l/bl8.jpg'),
        // require('../../assets/business_img_l/bl9.jpg'),
        // require('../../assets/business_img_l/bl10.jpg'),
        // require('../../assets/business_img_l/bl11.jpg'),
        // require('../../assets/business_img_l/bl12.jpg'),
        // require('../../assets/business_img_l/bl13.jpg'),
        // require('../../assets/business_img_l/bl14.jpg'),
        // require('../../assets/business_img_l/bl15.jpg'),
        // require('../../assets/business_img_l/bl16.jpg'),
        // require('../../assets/business_img_l/bl17.jpg'),
        // require('../../assets/business_img_l/bl18.jpg'),
        // require('../../assets/business_img_l/bl19.jpg'),
        // require('../../assets/business_img_l/bl20.jpg'),
        // require('../../assets/business_img_l/bl21.jpg'),
        // require('../../assets/business_img_l/bl22.jpg'),
        // require('../../assets/business_img_l/bl23.jpg'),
        // require('../../assets/business_img_l/bl24.jpg')
      ]
    }
  },
  methods: {
    goHome () {
      this.$router.push(
        {
          path: '/'
        }
      )
      location.reload()
    },
    autoPlay () {
      this.mark++
      if (this.mark === 24) {
        this.mark = 0
      }
    },
    play () {
      this.timer = setInterval(this.autoPlay, 2500)
    },
    change (i) {
      this.mark = i
    },
    stop () {
      clearInterval(this.timer)
    },
    move () {
      this.timer = setInterval(this.autoPlay, 5000)
    },
    changeImg (m) {
      console.log(m + '----------')
      console.log(this.imgArray[m] + '---' + m)
      console.log(document.getElementById('bigImg').src)
      document.getElementById('bigImg').src = this.imgArray[m]
      this.change(m)
      this.stop()
      this.move()
    }
  },
  created () {
    this.play()
  }
}
</script>
<style scoped>
#business-left ul {
        float: left;
        list-style: none;
}
#business-left ul li {
        display: inline;
    }
@media screen and (min-width: 1500px){
/* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 900px;
  margin-top: 25px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: 1%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: auto;
  height: auto;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 12%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_three{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 资质 */
#business-left{
  width: 640px;
  float: left;
  margin-left: 14.5%;
  margin-top: 20px;
  padding-bottom: 50px;
}
#business-left img{
    width: 16%;
    height: auto;
    cursor: pointer;
  }
/* .business iframe{
  width: 40%;
  height: 710px;
  margin-left: 14.5%;
  margin-top: 1%;
  padding-bottom: 50px;
} */
.slide {
    float: right;
    width: 450px;
    height: 600px;
    /* margin: 0 auto; */
    margin-right: 13%;
    margin-top: 20px;
    overflow: hidden;
    position: relative;
  }
  .slideshow {
    width: 100%;
    height: auto;
  }
  .slideshow ul{
    width:100%;
    height: auto;
  }
  .slideshow ul li {
    width:100%;
    position: absolute;
  }
  .slideshow ul a{
    display: inline-block;
    width:100%;
  }
  .slideshow img {
    width: 100%;
    height: auto;
  }
  .active {
    background: red !important;
  }
  .image-enter-active {
    transform: translateX(0);
    transition: all 1.5s ease;
  }
  .image-leave-active {
    transform: translateX(-100%);
    transition: all 1.5s ease;
  }
  .image-enter {
    transform: translateX(100%);
  }
  .image-leave {
    transform: translateX(0);
  }
}
@media screen and (min-width: 1200px) and (max-width:1499px){
/* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 750px;
  margin-top: 20px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -3%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 15%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_three{
  background-color: #F15A24;
}
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 资质 */
#business-left{
  width: 40%;
  float: left;
  margin-left: 14.5%;
  margin-top: 20px;
  padding-bottom: 50px;
}
#business-left img{
    width: 14%;
    height: auto;
    cursor: pointer;
  }
/* .business iframe{
  width: 40%;
  height: 700px;
  margin-left: 14.5%;
  margin-top: 1%;
  padding-bottom: 50px;
} */
/* #business-left{
  width: 40%;
  margin-left: 14.5%;
  margin-top: 1%;
  float: left;
}
#business-left img{
  width: auto;
  height: auto;
  cursor: pointer;
} */
.slide {
    float: right;
    width: 360px;
    height: 600px;
    /* margin: 0 auto; */
    margin-right: 8%;
    margin-top: 20px;
    overflow: hidden;
    position: relative;
  }
  .slideshow {
    width: 100%;
    height: auto;
  }
  .slideshow ul{
    width:100%;
    height: auto;
  }
  .slideshow ul li {
    width:100%;
    position: absolute;
  }
  .slideshow ul a{
    display: inline-block;
    width:100%;
  }
  .slideshow img {
    width: 100%;
    height: auto;
  }
  .active {
    background: red !important;
  }
  .image-enter-active {
    transform: translateX(0);
    transition: all 1.5s ease;
  }
  .image-leave-active {
    transform: translateX(-100%);
    transition: all 1.5s ease;
  }
  .image-enter {
    transform: translateX(100%);
  }
  .image-leave {
    transform: translateX(0);
  }

}
@media screen and (min-width: 960px) and (max-width:1199px){
/* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 600px;
  /* margin-left: 20px; */
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -6%;
  margin-left: 14.5%;
  font-size: 16px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_three{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 资质 */
#business-left{
  width: 40%;
  float: left;
  margin-left: 14.5%;
  margin-top: 20px;
  padding-bottom: 50px;
}
#business-left img{
    width: 14%;
    height: auto;
    cursor: pointer;
  }
/* .business iframe{
  width: 40%;
  height: 700px;
  margin-left: 14.5%;
  margin-top: 1%;
  padding-bottom: 50px;
} */
.slide {
    float: right;
    width: 320px;
    height: 600px;
    /* margin: 0 auto; */
    margin-right: 5%;
    margin-top: 20px;
    overflow: hidden;
    position: relative;
  }
  .slideshow {
    width: 100%;
    height: auto;
  }
  .slideshow ul{
    width:100%;
    height: auto;
  }
  .slideshow ul li {
    width:100%;
    position: absolute;
  }
  .slideshow ul a{
    display: inline-block;
    width:100%;
  }
  .slideshow img {
    width: 100%;
    height: auto;
  }
  .active {
    background: red !important;
  }
  .image-enter-active {
    transform: translateX(0);
    transition: all 1.5s ease;
  }
  .image-leave-active {
    transform: translateX(-100%);
    transition: all 1.5s ease;
  }
  .image-enter {
    transform: translateX(100%);
  }
  .image-leave {
    transform: translateX(0);
  }
}
@media screen and (min-width: 768px) and (max-width:959px){
/* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 400px;
  /* margin-left: 30px; */
  /* margin-top: 10px; */
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -11%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 20px;
  float: left;
  text-align: center;
  line-height: 20px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_three{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 20px;
}
/* 资质 */
#business-left{
  width: 40%;
  float: left;
  margin-left: 14.5%;
  margin-top: 20px;
  padding-bottom: 50px;
}
#business-left img{
    width: 14%;
    height: auto;
    cursor: pointer;
  }
/* .business iframe{
  width: 40%;
  height: 700px;
  margin-left: 14.5%;
  margin-top: 1%;
  padding-bottom: 50px;
} */
.slide {
    float: right;
    width: 300px;
    height: 600px;
    /* margin: 0 auto; */
    margin-right: 2%;
    margin-top: 20px;
    overflow: hidden;
    position: relative;
  }
  .slideshow {
    width: 100%;
    height: auto;
  }
  .slideshow ul{
    width:100%;
    height: auto;
  }
  .slideshow ul li {
    width:100%;
    position: absolute;
  }
  .slideshow ul a{
    display: inline-block;
    width:100%;
  }
  .slideshow img {
    width: 100%;
    height: auto;
  }
  .active {
    background: red !important;
  }
  .image-enter-active {
    transform: translateX(0);
    transition: all 1.5s ease;
  }
  .image-leave-active {
    transform: translateX(-100%);
    transition: all 1.5s ease;
  }
  .image-enter {
    transform: translateX(100%);
  }
  .image-leave {
    transform: translateX(0);
  }
}
@media screen and (min-width: 702px) and (max-width:767px){
/* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 500px;
  margin-left: 50px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -12%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 20px;
  float: left;
  text-align: center;
  line-height: 20px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_three{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 20px;
}
/* 资质 */
#business-left{
  width: 40%;
  float: left;
  margin-left: 14.5%;
  margin-top: 20px;
  padding-bottom: 50px;
}
#business-left img{
    width: 14%;
    height: auto;
    cursor: pointer;
  }
/* .business iframe{
  width: 40%;
  height: 700px;
  margin-left: 14.5%;
  margin-top: 1%;
  padding-bottom: 50px;
} */
.slide {
    float: right;
    width: 300px;
    height: 600px;
    /* margin: 0 auto; */
    margin-right: 2%;
    margin-top: 20px;
    overflow: hidden;
    position: relative;
  }
  .slideshow {
    width: 100%;
    height: auto;
  }
  .slideshow ul{
    width:100%;
    height: auto;
  }
  .slideshow ul li {
    width:100%;
    position: absolute;
  }
  .slideshow ul a{
    display: inline-block;
    width:100%;
  }
  .slideshow img {
    width: 100%;
    height: auto;
  }
  .active {
    background: red !important;
  }
  .image-enter-active {
    transform: translateX(0);
    transition: all 1.5s ease;
  }
  .image-leave-active {
    transform: translateX(-100%);
    transition: all 1.5s ease;
  }
  .image-enter {
    transform: translateX(100%);
  }
  .image-leave {
    transform: translateX(0);
  }
}
@media screen and (max-width:701px){
.main{
    width: 100%;
  }
  /* 顶部 */
.head{
  width: 100%;
  height: auto;
  background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.title{
  width: 50%;
  margin-left: 30%;
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: 10px;
  margin-left: 10%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 6%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
/* .lead{
  margin-left: 61%;
  margin-bottom: 0;
} */
.lead ul{
  list-style: none;
  margin-top: 20px;
}
.lead ul li{
  width: 20%;
  height: 14px;
  float: left;
  text-align: center;
  line-height: 12px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_three{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 34px;
}
/* 资质 */
/* .business iframe{
  width: 40%;
  height: 700px;
  margin-left: 14.5%;
  margin-top: 1%;
  padding-bottom: 50px;
} */
#business-left{
  width: 40%;
  float: left;
  margin-left: 14.5%;
  margin-top: 20px;
  padding-bottom: 50px;
}
#business-left img{
    width: 14%;
    height: auto;
    cursor: pointer;
  }
.slide {
    float: right;
    width: 30%;
    height: 600px;
    /* margin: 0 auto; */
    margin-right: 10%;
    margin-top: 20px;
    overflow: hidden;
    position: relative;
  }
  .slideshow {
    width: 100%;
    height: auto;
  }
  .slideshow ul{
    width:100%;
    height: auto;
  }
  .slideshow ul li {
    width:100%;
    position: absolute;
  }
  .slideshow ul a{
    display: inline-block;
    width:100%;
  }
  .slideshow img {
    width: 100%;
    height: auto;
  }
  .active {
    background: red !important;
  }
  .image-enter-active {
    transform: translateX(0);
    transition: all 1.5s ease;
  }
  .image-leave-active {
    transform: translateX(-100%);
    transition: all 1.5s ease;
  }
  .image-enter {
    transform: translateX(100%);
  }
  .image-leave {
    transform: translateX(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aboutMe/business.vue